import { IconsProps } from 'src/svgs/Viagogo/icon-types';
import { SvgWrapper } from 'src/svgs/Viagogo/svg-wrapper/icon-wrapper';

export function NavBoostCreditIcon(props: IconsProps) {
  return (
    <SvgWrapper {...props}>
      <g transform="translate(2 2)">
        <path
          d="M17 10V17.52C17 17.7851 16.765 18 16.475 18H3.525C3.23505 18 3 17.7851 3 17.52V10"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.52 5H2.48C2.2149 5 2 5.26863 2 5.6V9.4C2 9.7314 2.2149 10 2.48 10H17.52C17.7851 10 18 9.7314 18 9.4V5.6C18 5.26863 17.7851 5 17.52 5Z"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10 17.5L10 5.37378"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.1667 4.54028H7.4881C7.09343 4.54028 6.71492 4.40859 6.43585 4.17417C6.15678 3.93975 6 3.6218 6 3.29028C6 2.95876 6.15678 2.64082 6.43585 2.4064C6.71492 2.17198 7.09343 2.04028 7.4881 2.04028C9.57143 2.04028 10.1667 4.54028 10.1667 4.54028Z"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.167 4.54028H12.8456C13.2402 4.54028 13.6187 4.40859 13.8978 4.17417C14.1769 3.93975 14.3337 3.6218 14.3337 3.29028C14.3337 2.95876 14.1769 2.64082 13.8978 2.4064C13.6187 2.17198 13.2402 2.04028 12.8456 2.04028C10.7622 2.04028 10.167 4.54028 10.167 4.54028Z"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </SvgWrapper>
  );
}
